export const VIDEO_PERSISTENT_PLAYER_UPDATE = "video_persistent_player_update";
export const VIDEO_PERSISTENT_PLAYER_NULL = "video_persistent_player_null";
